import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockRotateLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2466_309768)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23147 15.6494C8.35049 18.0532 12.8276 17.4734 15.2315 14.3544C17.6353 11.2354 17.0555 6.75824 13.9365 4.35441C10.8175 1.95059 6.34032 2.53037 3.9365 5.64939C2.88427 7.01467 2.40373 8.64018 2.45759 10.2381",
				stroke: "#42229C",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.16797 7.5V11.0651H12.733",
				stroke: "#42229C",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.5 11.668L0.334936 9.16797L4.66506 9.16797L2.5 11.668Z",
				fill: "#42229C"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2466_309768",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgClockRotateLeft;
